/**
 * FREAK'S store 帯（collection-with-sidebar / about .xo-shop-the-look-unit--freaks-store）専用カート追加。
 * v2: data-spf-collection を collection.handle に修正、ルート検出を複数手段に拡張。
 */
(function () {
  const FREAKS_HANDLE = 'freaks-store';

  function getMain() {
    return document.getElementById('xo-main-content');
  }

  /** 旧テーマ互換: /collections/freaks-store や freaks-store の両方 */
  function isFreaksCollectionAttr(value) {
    if (!value) return false;
    var v = String(value).trim();
    return v === FREAKS_HANDLE || v === '/collections/' + FREAKS_HANDLE || v.endsWith('/' + FREAKS_HANDLE);
  }

  function freaksRoot() {
    var main = getMain();
    if (!main) return null;

    var grids = main.querySelectorAll('.collection-with-sidebar[data-spf-collection]');
    for (var i = 0; i < grids.length; i++) {
      if (isFreaksCollectionAttr(grids[i].getAttribute('data-spf-collection'))) {
        return grids[i];
      }
    }

    var sections = main.querySelectorAll('.xo-section.coll-sidebar-pm-compact');
    for (var j = 0; j < sections.length; j++) {
      if (sections[j].querySelector('img[src*="freaks_white"]')) {
        return sections[j].querySelector('.collection-with-sidebar') || sections[j];
      }
    }

    var bySectionClass = main.querySelector('.xo-section[class*="collection_with_sidebar_dLYgVr"]');
    if (bySectionClass) {
      return bySectionClass.querySelector('.collection-with-sidebar') || bySectionClass;
    }

    /* about ページ FREAK'S 帯（.xo-shop-the-look-unit--freaks-store） */
    var aboutFreaks = main.querySelector('.xo-shop-the-look-unit--freaks-store');
    if (aboutFreaks) return aboutFreaks;

    return null;
  }

  function cartAddUrl() {
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (!base.endsWith('/')) base += '/';
    return base + 'cart/add';
  }

  function serviceSectionIds() {
    if (window.Xotiny) {
      var cart = document.querySelector('xo-cart');
      var mini = document.querySelector('xo-cart-mini');
      var cartId = cart && cart.id;
      var miniId = mini && mini.id;
      if (window.location.pathname.indexOf('/cart') !== -1) {
        return [cartId, miniId].filter(Boolean);
      }
      return [miniId].filter(Boolean);
    }
    var cartNote = document.querySelector('cart-notification');
    var cartItems = document.querySelector('.shopify-section[id^="shopify-section-template--"][id$="__cart-items"]');
    var cartFooter = document.querySelector('.shopify-section[id^="shopify-section-template--"][id$="__cart-footer"]');
    function stripShopifySectionId(el) {
      if (!el || !el.id) return '';
      return el.id.replace(/^shopify-section-/g, '');
    }
    var cartItemSectionId = stripShopifySectionId(cartItems);
    var cartFooterSectionId = stripShopifySectionId(cartFooter);
    if (cartNote) {
      return window.location.pathname.indexOf('/cart') !== -1
        ? [cartItemSectionId, cartFooterSectionId, 'cart-icon-bubble', 'cart-live-region-text'].filter(Boolean)
        : ['cart-notification-product', 'cart-notification-button', 'cart-icon-bubble'];
    }
    return window.location.pathname.indexOf('/cart') !== -1
      ? [cartItemSectionId, cartFooterSectionId, 'cart-icon-bubble', 'cart-live-region-text'].filter(Boolean)
      : ['cart-drawer', 'cart-icon-bubble'];
  }

  function clearStuckCartLoading() {
    if (!window.xoStore || typeof window.xoStore.set !== 'function') return;
    var out = window.xoStore.set('xo-cart', function (prev) {
      return Object.assign({}, prev, { addIdLoading: '' });
    });
    if (typeof out === 'function') out('collection-freaks-cart-add-fallback-clear-loading');
  }

  function openCartDrawer() {
    var cartMini = document.querySelector('xo-cart-mini');
    if (cartMini && window.xoModal && typeof window.xoModal.open === 'function') {
      var modal = cartMini.closest('xo-modal');
      var name = (modal && modal.getAttribute('xo-name')) || 'cart';
      window.xoModal.open(name);
      return;
    }
    if (window.xoModal && typeof window.xoModal.open === 'function') {
      window.xoModal.open('cart');
    }
  }

  function resolveCartAddFromClick(node, freak) {
    if (!(node instanceof Element)) return null;

    var cartAdd = node.closest('xo-cart-add');
    if (!cartAdd || !freak.contains(cartAdd)) return null;

    var btn = cartAdd.querySelector('button');
    if (node.closest('button')) {
      btn = node.closest('button');
    } else if (node === cartAdd || cartAdd.getAttribute('data-button') === 'true') {
      btn = cartAdd.querySelector('button') || cartAdd;
    } else if (!btn) {
      return null;
    }

    if (cartAdd.hasAttribute('xo-disabled')) return null;

    var variantId = cartAdd.getAttribute('xo-variant-id');
    if (!variantId) return null;

    return { cartAdd: cartAdd, btn: btn, variantId: variantId, productId: cartAdd.getAttribute('xo-product-id') || '' };
  }

  var busy = false;

  async function postAddToCart(ctx) {
    if (busy) return;
    busy = true;

    var cartAdd = ctx.cartAdd;
    var btn = ctx.btn;
    var variantId = ctx.variantId;
    var productId = ctx.productId;

    clearStuckCartLoading();

    var qtyAttr = cartAdd.getAttribute('xo-product-quantity');
    var quantity = qtyAttr != null && qtyAttr !== '' ? String(Math.max(1, parseInt(qtyAttr, 10) || 1)) : '1';

    var fd = new FormData();
    fd.append('form_type', 'product');
    fd.append('utf8', '\u2713');
    fd.append('id', variantId);
    fd.append('quantity', quantity);
    fd.append('product-id', productId);
    var sections = serviceSectionIds();
    fd.append('sections', Array.isArray(sections) ? sections.join(',') : String(sections));
    fd.append('section_url', window.location.pathname);

    try {
      if (btn && btn.setAttribute) btn.setAttribute('disabled', 'disabled');

      var res = await fetch(cartAddUrl(), {
        method: 'POST',
        body: fd,
        headers: {
          Accept: 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest',
        },
      });

      if (res.status === 404 || res.status === 422) return;

      var text = await res.text();
      var data = null;
      try {
        data = text ? JSON.parse(text) : null;
      } catch (_) {
        return;
      }
      if (data && data.status) return;

      if (window.xoStore && typeof window.xoStore.set === 'function') {
        var next = function (prevState) {
          return Object.assign({}, prevState, {
            size: (prevState && prevState.size != null ? prevState.size : 0) + (parseInt(quantity, 10) || 1),
            sections: (data && data.sections) || (prevState && prevState.sections) || {},
            item: data,
            addIdLoading: '',
            isAdded: true,
            variantId: String(variantId),
            addErrorMessage: '',
            productIdsForCartNotification: data && data.product_id ? [String(data.product_id)] : undefined,
          });
        };
        var out = window.xoStore.set('xo-cart', next);
        if (typeof out === 'function') out('collection-freaks-cart-add-fallback');
      }

      openCartDrawer();
    } catch (_) {
      /* ignore */
    } finally {
      if (btn && btn.removeAttribute) btn.removeAttribute('disabled');
      busy = false;
    }
  }

  function freaksCartAddClickCapture(e) {
    if (e.type !== 'click' || e.button !== 0) return;

    var freak = freaksRoot();
    if (!freak) return;

    var rawTarget = e.target;
    var node = rawTarget && rawTarget.nodeType === 3 ? rawTarget.parentElement : rawTarget;
    var ctx = resolveCartAddFromClick(node, freak);
    if (!ctx) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    void postAddToCart(ctx);
  }

  function bind() {
    window.removeEventListener('click', freaksCartAddClickCapture, true);
    window.addEventListener('click', freaksCartAddClickCapture, true);
  }

  function boot() {
    if (!getMain()) return;
    bind();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
